import UnknownComponent from './UnknownComponent';

export { isUnknownComponent } from './UnknownComponent';

export default UnknownComponent;
